<script setup lang="ts">
import { IconName, IconFolder, IconSize } from './odsIcon.ts';
import { PropType, ref, onMounted, inject } from 'vue';

const odsIconPath = inject('odsIconPath','../../assets/icons')

const props = defineProps({
    /* 
    * To browse the icon library, please refer to :
    * https://fonts.google.com/icons?icon.size=24&icon.color=%23e8eaed&icon.platform=web&icon.style=Outlined 
    * 
    * Names must match SVG names so : "Partly Cloudy Day" becomes "partly_cloudy_day"
    */
    name: {
        type: String as PropType<IconName | String>,
        default: IconName.Default
    },
    folder: {
        type: String as PropType<IconFolder>,
        default: IconFolder.Default
    },
    size: {
        type: String as PropType<IconSize>,
        default: IconSize.Default
    }
})

const currentIcon = ref("")

onMounted(async () => {
    currentIcon.value = (await import( /* @vite-ignore */ `${odsIconPath}/${props.folder}/${props.name}.js`)).default
})


</script>

<template>
    <div class="ods-icon" :class="['icon-size-'+size, {'ods-svg-fill-current' : folder === IconFolder.Material}]" v-html="currentIcon">
    </div>
</template>

<style lang="scss" src="./odsIcon.scss"></style>